<script>
	// Stores 
	import { 
		mailAtendimento, 
		mailLocacao, 
		mailVendas,
        mailCondominios, 
		mailOuvidoria, 
		textSite, 
		textEndereco, 
		textAtendimento,
		linkIframeMapa,
		comoChegar,
	} from '../store.js';    

	// Componentes
	import { link } from "svelte-routing";

	import Forms from "../components/Forms.svelte";  
	import BarraAtendimento from "../components/BarraAtendimento.svelte"; 
	import PageHeader from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Fale Conosco ';

	let mensagem = GetHash('assunto') == null ? '' : GetHash('assunto');

	let enderecoSimples = $textEndereco.replaceAll('<br class=\'hidden-sm hidden-xs\'>', '');
	let atendimentoSimples = $textAtendimento.replaceAll('<br class=\'hidden-sm hidden-xs\'>', '');

	let fields = [
		{
			title:  'Nome *',
			name:   'nome',
			required: 'required'
		},
		{
			title:  'Telefone *',
			name:   'telefone',
			required: 'required',
			classe: 'mask-telefone',
		},
		{
			title:  'Email *',
			name:   'email',
			type:   'email',
			required: 'required',
		},
		{
			title:  'Destino',
			name:   'destino',
			type:   'select',
			selectValues: [
				{
					title: 'Atendimento Geral',
					value: $mailAtendimento
				},
				{
					title: 'Condomínios',
					value: $mailCondominios
				},
				{
					title: 'Locação',
					value: $mailLocacao
				},
				{
					title: 'Vendas',
					value: $mailVendas
				},
				{
					title: 'Ouvidoria',
					value: $mailOuvidoria
				},
			]
		},
		{
			title:     'Mensagem *',
			name:      'mensagem',
			required:  'required',
			type:      'textarea',
			rows: 4,
			defaultValue:      mensagem
		}
	];
	const message = `
Nome: {nome}
Telefone: {telefone}
Email: {email}
Mensagem: {mensagem}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}
</script>

<PageHeader title={titlePage} buttons="">
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<p>Para dúvidas ou maiores informações, preencha o formulário abaixo com seus dados e nossa equipe irá retornar o mais breve possível.</p>
		</div>
	</div>
</PageHeader>

<div class="container">
	<div class="grid grid-size--2 grid-size-sm--1">
		<BarraAtendimento />
		<section class="atendimento">
			<div class="text-center">
				<h3><i class="fas fa-envelope color-secondary"></i> Entre em contato com a gente</h3>
			</div>	
			<div class="flex flex-center mt-20 mb-20">
				<div class="flex-1 background-gray round-all pa-30">
					<Forms destiny={''} fields={fields} {message} htmlbody={false} />
				</div>
			</div>
		</section>
	</div>
</div>

<div class="mapa">
	<div class="container">
		<div class="flex flex-spaced sm-flex-column mt-60 mb-40 gap-10">
			<h3><i class="far fa-map-marker-alt"></i> Endereço: {@html enderecoSimples}</h3>
			<div class="flex flex-end sm-flex-center flex-1 gap-10">
				{#each $comoChegar as l}
				<div class="item">
					<a href="{l.link}" target="_blank" title="{$textSite} via {l.title}">
						{@html l.icon} {l.title} 
					</a>
				</div>
				{/each}
			</div>
		</div>
	</div>
	<iframe style="width:100%;" height="500" id="gmap_canvas" src="{$linkIframeMapa}" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
</div>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'
</style>